<template>
    <div>
      <!-- 优惠券弹窗 -->
      <div class="mask Enrolment-Show" @touchmove.prevent>
          <!-- <div style="position: absolute;width:100%;height:100vh;top:0;left:0;" @click="maskHide" @touchmove.prevent></div> -->
          <div class="showMasks">
              <img src="@/assets/home/Receive_bg@3x.png" alt="" class="testImg">
              <p class="coupon-title">限时领取600元优惠券</p>
              <p class="coupon-tips">*请准确填写以下信息领取</p>
              <div class="coupon-input flex flex-a-i-center flex-j-c-sb">
                  <div class="flex flex-a-i-center">
                      <img src="@/assets/home/Receive_icon_iphone@3x.png" class="coupon-phone">
                      <input type="number" placeholder="请输入您的手机号" ref="phone" oninput="if(value.length > 11)value = value.slice(0, 11)"
                        @blur="checkPhoneNum()"/>
                  </div>
                  <div class="flex flex-a-i-center">
                      <img src="@/assets/home/Receive_icon_Password@3x.png" class="coupon-phone">
                      <input type="text" placeholder="请输入验证码" class="coupon-check" ref="phonecheck" oninput="if(value.length > 6)value = value.slice(0, 6)"/>
                      <div class="btn-box">
                          <span class="check-btn" v-if="seconds < 60" style="color:#7381FF">{{seconds}}S</span>
                          <span class="check-btn" @click="getCode" v-else>获取验证码</span>
                      </div>
                  </div>
                  <div :style="{'background-image': 'url('+ couponbtn +')'}" class="coupon-submit" @click="getNewCoupon">立即提交</div>
              </div>
          </div>
          <img src="@/assets/home/Receive_icon_close@3x.png" class="hasCoupon-close" @click="maskHide" style="top:15%;left:90%;">
      </div>
      <!-- 优惠券领取成功 -->
      <div class="mask" @touchmove.prevent :class="!hasCoupon ? 'Enrolment-Hide':'Enrolment-Show'">
          <div :style="{'background-image': 'url('+ hascouponimg +')'}" class="hasCoupon">
              <p>恭喜领取成功</p>
              <p>此券用于第一学期学费抵扣</p>
          </div>
          <img src="@/assets/home/Receive_icon_close@3x.png" class="hasCoupon-close" @click="closeMask">
      </div>
    </div>
</template>

<script>
import { MessageBox, Toast } from 'mint-ui';
import {getMessage, getCoupon, becomefans, inviterInfo} from '@/api';

export default {
  name: 'Masks',
  // props: {
  //   showMask: Boolean,
  // },
  data() {
    return {
      // couponimg: require('@/assets/home/Receive_bg@3x.png'),
      couponbtn: require('@/assets/home/Receive_btn@3x.png'),
      hascouponimg: require('@/assets/home/Receive_bg02@3x.png'), 
      seconds: 61, // 验证码倒计时
      hasCoupon: false, // 领取优惠券成功
      uphone: '', // 手机号码
      showMask: false,
    }
  },
  created() {
    // setTimeout(() => {
      this.showMask = true
    // }, 300);
  },
  methods: {
    // 获取验证码
    getCode() {
      if (!this._tools.checkPhone(this.uphone)) {
        Toast({message: '请输入正确的手机号码', className: 'iconfont icon-close'});
        return false;
      }
      if (this.seconds < 61) return
      this.seconds--;
      if (true) {
        this.requestCode();
      } else {
        console.log('error')
      }
    },
    // 获取短信验证码
    requestCode() {
      getMessage({content: this.uphone}).then(res => {
        if (res.code === 0) {
          MessageBox('提示', '验证码发送，请注意查收！');
          this.t = setInterval(() => {
            this.seconds--
            if (this.seconds === 0) {
              clearInterval(this.t)
              this.seconds = 61;
            }
          }, 1000)
        } else {
          Toast({message: res.msg, className: 'iconfont icon-close'});
          this.seconds = 61;
        }
      })
    },
    // 领取优惠券
    getNewCoupon() {
      if (!this.uphone || !this.$refs.phonecheck.value) {
        Toast({message: '请输入手机号和验证码', className: 'iconfont icon-close', duration: 1500});
        return false;
      }
      let params = {
        mobile: this.uphone,
        mobile_code: this.$refs.phonecheck.value
      }
      getCoupon(params).then(res => {
        if (res.code === 0) {
          // Toast({message: '领取成功', duration: 1500});
          this.hasCoupon = true;
        } else {
          Toast({message: res.msg, duration: 1500});
        }
      })
    },
    checkPhoneNum(){
      if (!this.$refs.phone.value) return false;
      if (!this._tools.checkPhone(String(this.$refs.phone.value))) {
        Toast({message: '请输入正确的手机号码', className: 'iconfont icon-close', duration: 1500});
      } else {
        this.uphone = this.$refs.phone.value;
      }
    },
    // 关闭优惠券弹窗
    closeMask() {
      this.hasCoupon = false;
      // this.$emit('update:showMask', false);
      this.$router.go(-1);
    },
    maskHide() {
      // this.$emit('update:showMask', false);
      this.$router.go(-1);
    }
  },
};
</script>

<style scoped lang="less">
.showMasks{
    width: 3.38rem;
    height: 3.45rem;
    position: absolute;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .coupon-title{
        margin-top: 0.8rem;
        font-size: 0.2rem;
        color: white;
        letter-spacing: 1.5px;
    }
    .coupon-tips{
        font-size: 0.12rem;
        color: white;
        letter-spacing: 1px;
    }
    .coupon-input{
        width: 3rem;
        height: 1.92rem;
        border-radius: 6px;
        background: white;
        margin: 0.1rem auto;
        padding: 0.2rem;
        flex-direction: column;
        &>div{
            width: 2.62rem;
            height: 0.44rem;
            background: #EBEBEB;
            border-radius: 5px;
            position: relative;
            input{
                border: none;
                padding-top: 0.05rem;
                background: #EBEBEB;
                height: 0.25rem;
                line-height: 0.25rem;
            }
        }
        .coupon-check{
            width: 1rem;
        }
        
        .coupon-submit{
            line-height: 0.44rem;
            color: white;
            font-size: 0.18rem;
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
        .coupon-phone{
            width: 0.26rem;
            height: 0.26rem;
            margin: 0 0.06rem;
        }
        .btn-box{
            position: absolute;
            right: 0.05rem;
            height: 0.3rem;
            width: 0.8rem;
            .check-btn{
                position: absolute;
                display: block;
                width: 0.8rem;
                height: 0.24rem;
                line-height: 0.24rem;
                background: #F6F6FA;
                color: #333333;
                font-size: 0.14rem;
                top: 50%;
                transform: translateY(-50%);
                border-radius: 0.12rem;
            }
        }
    }
}
.hasCoupon{
    width: 2.6rem;
    height: 1.62rem;
    position: absolute;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    p{
        font-size: 0.1rem;
        color: #666666;
        margin-top: 0.05rem;
    }
    p:first-child{
        font-size: 0.17rem;
        margin-top: 0.97rem;
        letter-spacing: 1.5px;
    }
}
.hasCoupon-close{
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translateX(-50%);
}
// .mask{
//   display: none;
// }
.testImg{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
</style>
